// React
import { useState } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Mantine notifications
import { notifications } from '@mantine/notifications'

export default function useRetailer() {
    // State
    const [retailer, setRetailer] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    // Clearing
    const clearRetailer = () => {
        setRetailer(null)
    }

    // Fetching
    const { requestGet } = useAxiosApi()

    const loadRetailer = async (retailerId) => {
        setIsLoading(true)

        try {
            const { data } = await requestGet(`/retailers/${retailerId}`)

            // Check if retailer has an invoicing address
            if (data.sellsy_billing_address) {
                setRetailer(data)
            } else {
                // Display a notification
                notifications.show({
                    title: 'Aucune adresse de facturation',
                    color: 'red',
                    message:
                        'Impossible de créer un devis pour ce revendeur sans adresse de facturation.',
                    position: 'top-center',
                })
            }
        } finally {
            setIsLoading(false)
        }
    }

    // On Select
    const onSelect = (retailer) => {
        loadRetailer(retailer.id)
    }

    return {
        retailer,
        isLoading,
        clearRetailer,
        onSelect,
    }
}
